import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/web/$orgId/jobs/$jobId/workspace/form",
			params: { orgId: params.orgId, jobId: params.jobId },
		});
	},
});
